import React from "react";
import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";

const MovieGenre = () => {
  const [popularMovies, setPopularMovies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [visible, setVisible] = useState(10);
  const { genres } = useParams();

  useEffect(() => {
    setIsLoading(true);
    fetch(
      `https://api.themoviedb.org/3/discover/movie?api_key=375735221c3b7b45a786c79616eae571&language=en-US&with_genres=${genres}`
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        setPopularMovies(data.results);
        setIsLoading(false);
      });
  }, []);

  function loadMoreHandler() {
    setVisible((prevValue) => prevValue + 5);
  }
  return (
    <>
      {!isLoading && (
        <div>
          <div className="card__title">
            {/* <p className="title-section">{popularMovies.genre}</p> */}
          </div>
          <div className="popular">
            {popularMovies.slice(0, visible).map((movie) => {
              return (
                <Link key={movie.id} to={`/movie/${movie.id}`}>
                  <div className="card">
                    <img
                      className="card-image design-image"
                      src={`https://image.tmdb.org/t/p/original${movie.poster_path}`}
                      alt="movie"
                    />
                    <div className="card__content">
                      <p className="card-title">{movie.original_title}</p>
                      <p className="card_rating">
                        {" "}
                        {movie.vote_average} <i className="fa fa-star"></i>
                      </p>
                      <p className="card_desc">{movie.overview}</p>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
          <div className="button">
            <button onClick={loadMoreHandler}>Load More</button>
          </div>
        </div>
      )}
      {isLoading && (
        <p
          style={{
            fontSize: "50px",
            color: "red",
            textAlign: "center",
            marginTop: "50px",
            padding: "100px 0",
            fontWeight: "bold",
          }}
        >
          Loading......
        </p>
      )}
    </>
  );
};

export default MovieGenre;
